import { ConditionRegistryItem } from '../../ConditionRegistryItem';
import { ConditionRegistryCategory } from '../../ConditionRegistryCategory';
export class ConditionRegistryAspectMounted extends ConditionRegistryCategory {
    label = 'Dargestellter Aspekt';
    constructor(parent) {
        super(parent);
        super.init();
    }
    toAspect = () => new ConditionRegistryItem({
        /*  label: 'Dargestellten Aspekt wechseln',
        params: { core: ['aspectName'] }, */
        eval: ({ rightChildEvaluator }) => !!rightChildEvaluator && rightChildEvaluator.isConditionTrue,
        modifyContext: {
            aspect: context => context.aspect.actor.ownAspect[context.evaluator.valueOf.aspectName] // actorStore.aspects.get() || context.actor.actorAspects.allAspectsArray[0]
        }
    });
    toPersistentAspect = () => new ConditionRegistryItem({
        /*   label: 'Zu Persistentem Aspekt wechseln', */
        eval: ({ rightChildEvaluator }) => !!rightChildEvaluator && rightChildEvaluator.isConditionTrue,
        modifyContext: {
            aspect: context => {
                return context.aspect.persistentAspect;
            }
        }
    });
    isAspectHovering = () => new ConditionRegistryItem({
        /* label: 'hovering', */
        eval: ({ aspect }) => aspect.aspectInteract.isAspectHovering
    });
    isAspectActive = () => new ConditionRegistryItem({
        /* label: 'active (while clicking)', */
        eval: ({ aspect }) => aspect.aspectInteract.isAspectActive
    });
    isAspectFocused = () => new ConditionRegistryItem({
        eval: ({ aspect }) => aspect.aspectInteract.isAspectFocused
    });
    isOuterMostMountedAspect = () => new ConditionRegistryItem({
        /*  label: 'ist äußester Aspekt von Akteur', */
        eval: ({ aspect }) => aspect.aspectMount.isOutermostMountedAspectOfActor
    });
}
